import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { api } from '../utils'
import {
  getPaginaCondizioniServizio,
  getPaginaInformativaPrivacy,
} from '../utils/pagine'

export const usePrivacy = () => {
  const router = useRouter()
  const [InformativaPrivacy, setInformativaPrivacy] = useState(false)
  const [condizioniGenerali, setCondizioniGenerali] = useState(false)
  const { locale } = router
  const { privacy } = useSelector((state) => state.privacy)

  useEffect(() => {
    getInformativaPrivacy()
    getCondizioniGenerali()
  }, [router.isReady])

  const getUrlInformativaFromStore = () => {
    return privacy?.seo?.canonical_url
  }

  const getUrlInformativa = () => {
    return InformativaPrivacy?.seo?.canonical_url
  }

  const getUrlCondizioniGenerali = () => {
    return condizioniGenerali?.seo?.canonical_url
  }

  const getInformativaPrivacy = async () => {
    try {
      const { data } = await getPaginaInformativaPrivacy(api, locale)
      setInformativaPrivacy(data)
      return data
    } catch (error) {
      return {}
    }
  }

  const getCondizioniGenerali = async () => {
    try {
      const { data } = await getPaginaCondizioniServizio(api, locale)
      setCondizioniGenerali(data)
      return data
    } catch (error) {
      return {}
    }
  }

  return {
    getCondizioniGenerali,
    getInformativaPrivacy,
    InformativaPrivacy,
    condizioniGenerali,
    getUrlInformativaFromStore,
    getUrlInformativa,
    getUrlCondizioniGenerali,
  }
}

export default usePrivacy
